import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { lightenColor } from '../../util/style/lighten-color.util';
import { addOpacity } from '../../util/style/add-opacity.util';

const loaderPath = keyframes`
  5% {
    width: 8px;
    opacity: 1;
  }
  25% {
    width: 23px;
    x: 0;
  }
  50% {
    width: 8px;
    x: 15;
  }
  75% {
    width: 23px;
    x: 15;
  }
  95% {
    width: 8px;
    x: 30;
    opacity: 1;
  }
  100% {
    opacity: 0;
    x: 30;
  }
`;

const BulletSvg = styled.svg``;

const BulletRect = styled.rect`
  opacity: 0;
  animation: ${loaderPath} 2s ease-in-out infinite;
`;

export const Bullet = (props: { height: number; width: number; color: string; style: React.CSSProperties;  }) => {
  return (
    <BulletSvg
      width={props.width}
      height={props.height}
      style={props.style}
      viewBox="0 0 38 8"
    >
      <circle
        fill={addOpacity(lightenColor(props.color, -.75), 0.25)}
        cx="4"
        cy="4"
        r="4"
      />
      <circle
        fill={addOpacity(lightenColor(props.color, -.75), 0.25)}
        cx="19"
        cy="4"
        r="4"
      />
      <circle
        fill={addOpacity(lightenColor(props.color, -.75), 0.25)}
        cx="34"
        cy="4"
        r="4"
      />
      <BulletRect
        x="0"
        y="0"
        width="8"
        height="8"
        rx="4"
        ry="4"
        fill={props.color}
      />
    </BulletSvg>

  );
};
